'use strict';

// FundingSource workspace — a balance-bearing source of project funding (FundingSourceProject association).
// Overview + a Projects association tab.
module.exports = {
	Identifier: 'FundingSourceWorkspace', Ordinal: 258,
	Entity: { Name: 'FundingSource', IDField: 'IDFundingSource', Collection: 'FundingSources', GUIDField: 'GUIDFundingSource' },
	Header: { Eyebrow: 'Funding Source', Title: (r) => r.Name || `Funding Source ${r.IDFundingSource}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/FundingSource/List' },
	Tabs:
	[
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'projects', Label: 'Projects', Icon: 'fas fa-folder-open', Content: { kind: 'assoc', ref: 'FundingSourceProject' } },
	],
	FieldGroups:
	[
		{ Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'FundingSourceAccountCode', Label: 'Account Code', Mono: true }, { Key: 'Type', Label: 'Type' } ] },
		{ Name: 'Balance', Fields: [ { Key: 'Balance', Label: 'Balance', Format: 'currency' } ] },
		{ Name: 'Detail', Fields: [ { Key: 'Description', Label: 'Description', Wide: true } ] },
	],
};
